import React from 'react'
import { useTranslation } from 'react-i18next'
import { DrawerButton } from '../Drawer'

const DownloadButton = ({ className = 'button-new', onClick = () => { }, downloading, disabled, dataProviderName, recipe, recipes }) => {

    const { t } = useTranslation()

    const label = className === 'iconic' ? '' : t('Export')

    return !disabled && <DrawerButton
        className={className}
        disabled={disabled}
        drawerRoute='wizards/download'
        icon='faUpload'
        label={label}
        params={{ dataProviderName, recipe, recipes }}
        title={t('Export')}
    />

    // return (
    //     <Button
    //         onClick={onClick}
    //         disabled={disabled}
    //         className="button-export"
    //     >
    //         {downloading ? t('Downloading...') : t('Export')}
    //     </Button>
    // )
}

export default DownloadButton
